(function(){
  'use strict';

  function initSection(scriptEl){
    const sectionId = scriptEl.dataset.sectionId;
    const root = document.getElementById('bs-root-' + sectionId);
    if (!root || root.dataset.bsInit) return;
    root.dataset.bsInit = '1';

    const dataEl = document.getElementById('bs-product-data-' + sectionId);
    if (!dataEl) return;
    const productData = JSON.parse(dataEl.textContent);

    // real material swatch photos for Color — same load-check + fallback
    // pattern as Sign Studio: missing/failed file just falls back to a
    // flat fill rather than a blank plate
    const colorImagesEl = document.getElementById('bs-color-images-' + sectionId);
    let colorImages = {};
    let colorImagesReady = Promise.resolve();
    if (colorImagesEl){
      try {
        const raw = JSON.parse(colorImagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) colorImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000);
          });
        });
        colorImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to flat fills */ }
    }

    // ---- option config. Labels must match the Shopify variant option
    // values *exactly* (spelling/spacing/capitalization) — same contract as
    // Sign Studio's Size/Material/Mounting table. ----
    const SIZES = {
      s1:   { label: '1" x 3" Rectangle' },
      s125: { label: '1.25" x 3" Rectangle' },
      s15:  { label: '1.5" x 3" Rectangle' }
    };
    const COLORS = {
      gold:   { label: 'Gold',   plate: '#C9A227', suggestedText: '#241D0F' },
      silver: { label: 'Silver', plate: '#C7CBCE', suggestedText: '#1C1F26' },
      white:  { label: 'White',  plate: '#FFFFFF', suggestedText: '#1C1F26' }
    };
    const BACKINGS = {
      clip:   { label: 'Alligator Clip' },
      magnet: { label: 'Magnet Back' },
      pin:    { label: 'Pin Back' },
      pocket: { label: 'Pocket Holder' }
    };
    // Corner Style is a line-item property, not a real Shopify variant
    // (same pattern as Font / Imprint Color) — it doesn't move price.
    // 'rounded' keeps the plate's original rx so existing behavior/look
    // doesn't shift for anyone who doesn't touch this new chip.
    const CORNERS = {
      rounded: { label: 'Rounded Corners', rx: 6 },
      square:  { label: 'Square Corners',  rx: 0 }
    };
    const FONTS = {
      sans:      { label: 'Arial (Upper/Lower)', family: 'Arial, Helvetica, sans-serif', weight: 400, upper: false },
      sansCaps:  { label: 'Arial (All Caps)',    family: 'Arial, Helvetica, sans-serif', weight: 700, upper: true },
      script:    { label: 'Script',              family: '"Brush Script MT", cursive',   weight: 400, upper: false }
    };
    const IMPRINT_COLORS = {
      black: { label: 'Black', hex: '#1C1F26' },
      white: { label: 'White', hex: '#FFFFFF' },
      gold:  { label: 'Gold',  hex: '#8E7442' },
      navy:  { label: 'Navy',  hex: '#1F2A44' },
      red:   { label: 'Red',   hex: '#8C2F2A' }
    };
    const LOGO_LABELS = {
      none: 'No logo',
      left: 'Logo — left side',
      top:  'Logo — centered above text'
    };

    let rowSeq = 1;
    function newRow(){ return { id: 'r' + (rowSeq++), name:'', line2:'', line3:'', qty:1 }; }

    let state = {
      size:'s1', color:'gold', backing:'clip', corner:'rounded',
      font:'sans', imprintColor:'black', linesOfImprint:'2', logoOption:'none',
      rows: [ newRow() ]
    };

    // linesOfImprint is now a mode string, not a number: '1n' (Name only),
    // '1t' (Title only), '2' (Name+Title), '3' (Name+Title+Company).
    // These two helpers are the single source of truth for "how many text
    // lines" and "is the single line a Title instead of a Name" so the rest
    // of the file never has to parse the mode string itself.
    function lineCount(mode){ return (mode==='1n' || mode==='1t') ? 1 : (parseInt(mode,10)||1); }
    function isTitleOnly(mode){ return mode==='1t'; }

    // ---- variant lookup: Option1=Size, Option2=Color, Option3=Backing ----
    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.color + '|' + v.backing] = v;
    });
    function findVariant(){
      const key = SIZES[state.size].label + '|' + COLORS[state.color].label + '|' + BACKINGS[state.backing].label;
      return variantMap[key] || null;
    }

    function escapeXml(str){
      return String(str||'').replace(/[<>&"']/g, c=>({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":'&apos;'}[c]));
    }

    function buildChipRow(container, options, key){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'bs-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{ state[key] = k; renderAll(); });
        container.appendChild(btn);
      });
    }

    // ---- batch rows: rebuilt only on structural changes (add/remove row,
    // or Lines of Imprint changing which columns show) — never on every
    // keystroke, so typing doesn't lose focus/cursor position ----
    function buildRowsDOM(){
      const container = root.querySelector('#bs-rows');
      container.innerHTML = '';
      const count = lineCount(state.linesOfImprint);
      const titleOnly = isTitleOnly(state.linesOfImprint);
      state.rows.forEach((row, i)=>{
        const el = document.createElement('div');
        el.className = 'bs-row';
        el.dataset.rowId = row.id;
        el.innerHTML = `
          <input type="text" data-field="name" placeholder="${titleOnly ? 'Title' : 'Name'}" maxlength="40" value="${escapeXml(row.name)}">
          ${count>=2 ? `<input type="text" data-field="line2" placeholder="Title" maxlength="40" value="${escapeXml(row.line2)}">` : '<span></span>'}
          ${count>=3 ? `<input type="text" data-field="line3" placeholder="Company" maxlength="40" value="${escapeXml(row.line3)}">` : '<span></span>'}
          <input type="number" data-field="qty" min="1" max="500" value="${row.qty}">
          <button type="button" class="bs-row-remove" title="Remove" ${state.rows.length<=1 ? 'disabled style="opacity:0.25;cursor:not-allowed;"' : ''}>&times;</button>
        `;
        container.appendChild(el);
      });
    }

    function bindRowEvents(){
      const container = root.querySelector('#bs-rows');
      container.addEventListener('input', e=>{
        const rowEl = e.target.closest('.bs-row');
        if (!rowEl) return;
        const row = state.rows.find(r=>r.id===rowEl.dataset.rowId);
        if (!row) return;
        const field = e.target.dataset.field;
        if (field === 'qty'){
          row.qty = Math.max(1, Math.min(500, parseInt(e.target.value,10) || 1));
        } else if (field){
          row[field] = e.target.value;
        }
        renderSummaryAndPreview(); // no rebuild — keeps focus intact
      });
      container.addEventListener('click', e=>{
        if (!e.target.classList.contains('bs-row-remove')) return;
        const rowEl = e.target.closest('.bs-row');
        state.rows = state.rows.filter(r=>r.id!==rowEl.dataset.rowId);
        buildRowsDOM();
        renderSummaryAndPreview();
      });
    }

    // ---- live preview: a simple flat badge shape (all sizes here are
    // rectangles at different heights, unlike the room-sign shape system) ----
    function renderPreview(){
      const holder = root.querySelector('#bs-svg-holder');
      const color = COLORS[state.color];
      const font = FONTS[state.font];
      const ink = IMPRINT_COLORS[state.imprintColor].hex;
      const firstRow = state.rows[0] || { name:'', line2:'', line3:'' };

      const heightByS = { s1: 90, s125: 108, s15: 128 };
      const h = heightByS[state.size] || 90;
      const w = 300;
      const vbW = w+60, vbH = h+80;
      const px = (vbW-w)/2, py = (vbH-h)/2;

      // logo box scales with the badge's own size instead of a fixed 24px —
      // and carves out real space so text reflows around it rather than
      // risking overlap
      let logoBox = null, textAreaX = px, textAreaW = w, textAreaTopY = py, textAreaBottomY = py+h;
      if (state.logoOption==='left'){
        const logoSize = h*0.62;
        logoBox = { x: px+12, y: py+(h-logoSize)/2, w: logoSize, h: logoSize };
        textAreaX = logoBox.x + logoBox.w + 14;
        textAreaW = (px+w) - textAreaX - 10;
      } else if (state.logoOption==='top'){
        const logoW = w*0.30, logoH = h*0.34;
        logoBox = { x: px+(w-logoW)/2, y: py+8, w: logoW, h: logoH };
        textAreaTopY = logoBox.y + logoBox.h + 6;
      }
      const textCenterX = textAreaX + textAreaW/2;

      const xf = t => state.font==='sansCaps' ? String(t||'').toUpperCase() : (t||'');
      const count = lineCount(state.linesOfImprint);
      const titleOnly = isTitleOnly(state.linesOfImprint);
      const nameSize = h*0.30, line2Size = h*0.17, line3Size = h*0.14;
      const lines = [];
      lines.push({ text: xf(firstRow.name) || (titleOnly ? 'TITLE' : 'NAME'), size: nameSize, weight: 700 });
      if (count>=2) lines.push({ text: xf(firstRow.line2) || 'Title', size: line2Size, weight: 400 });
      if (count>=3) lines.push({ text: xf(firstRow.line3) || 'Company', size: line3Size, weight: 400 });

      const textAreaH = textAreaBottomY - textAreaTopY;
      const totalTextH = lines.reduce((s,l)=>s+l.size*1.25,0);
      let cursorY = textAreaTopY + textAreaH/2 - totalTextH/2 + lines[0].size*0.9;
      const textMarkup = lines.map(l=>{
        const markup = `<text x="${textCenterX}" y="${cursorY}" text-anchor="middle" font-family="${font.family}" font-weight="${l.weight}" font-size="${l.size}" fill="${ink}">${escapeXml(l.text)}</text>`;
        cursorY += l.size*1.25;
        return markup;
      }).join('');

      const backingMarkup = (function(){
        const cx = px+w/2;
        if (state.backing==='clip') return `<rect x="${cx-14}" y="${py-10}" width="28" height="10" rx="2" fill="#9aa0a6"/>`;
        if (state.backing==='pin') return `<circle cx="${cx}" cy="${py-4}" r="4" fill="#9aa0a6"/>`;
        if (state.backing==='magnet') return `<rect x="${cx-10}" y="${py-8}" width="20" height="6" rx="1" fill="#9aa0a6" opacity="0.7"/>`;
        return ''; // pocket holder: no visible hardware
      })();

      const artworkUrl = getArtworkUrl();
      const logoMarkup = !logoBox ? '' :
        artworkUrl
          ? `<image href="${artworkUrl}" x="${logoBox.x}" y="${logoBox.y}" width="${logoBox.w}" height="${logoBox.h}" preserveAspectRatio="xMidYMid meet"/>`
          : `<rect x="${logoBox.x}" y="${logoBox.y}" width="${logoBox.w}" height="${logoBox.h}" rx="3" fill="none" stroke="${ink}" stroke-width="1.5" opacity="0.5"/>`;

      const patternId = 'bs-plate-fill-' + sectionId;
      const plateFillDef = colorImages[state.color]
        ? `<defs><pattern id="${patternId}" patternUnits="objectBoundingBox" width="1" height="1"><image href="${colorImages[state.color]}" x="0" y="0" width="${w}" height="${h}" preserveAspectRatio="xMidYMid slice"/></pattern></defs>`
        : '';
      const plateFill = colorImages[state.color] ? `url(#${patternId})` : color.plate;

      const svg = `<svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg">
        ${plateFillDef}
        ${backingMarkup}
        <rect x="${px}" y="${py}" width="${w}" height="${h}" rx="${CORNERS[state.corner].rx}" fill="${plateFill}" stroke="rgba(0,0,0,0.18)"/>
        ${logoMarkup}
        ${textMarkup}
      </svg>`;
      holder.innerHTML = svg;

      root.querySelector('#bs-stage-dims').textContent = SIZES[state.size].label;
    }

    // ---- summary: price × total quantity across all rows, availability ----
    function renderSummary(){
      const variant = findVariant();
      const unitPriceEl = root.querySelector('#bs-unitPrice');
      const totalQtyEl = root.querySelector('#bs-totalQty');
      const totalPriceEl = root.querySelector('#bs-totalPrice');
      const unavailableEl = root.querySelector('#bs-unavailable');
      const addBtn = root.querySelector('#bs-addBtn');

      const totalQty = state.rows.reduce((s,r)=> s + (parseInt(r.qty,10)||0), 0);
      totalQtyEl.textContent = totalQty;

      const hasAnyName = state.rows.some(r=>r.name.trim()!=='');

      if (!variant){
        unitPriceEl.textContent = '—';
        totalPriceEl.textContent = '—';
        unavailableEl.textContent = "This exact Size/Color/Backing combination isn't available yet — try a different one.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
        return;
      }
      if (!variant.available){
        unitPriceEl.textContent = variant.price;
        totalPriceEl.textContent = '—';
        unavailableEl.textContent = 'This combination is currently out of stock.';
        unavailableEl.style.display = '';
        addBtn.disabled = true;
        return;
      }

      unavailableEl.style.display = 'none';
      const unitAmount = parseFloat(String(variant.price).replace(/[^0-9.]/g,'')) || 0;
      const currencyMatch = String(variant.price).match(/^[^\d]*/);
      const currencyPrefix = currencyMatch ? currencyMatch[0] : '';
      unitPriceEl.textContent = variant.price;
      totalPriceEl.textContent = currencyPrefix + (unitAmount*totalQty).toFixed(2);
      addBtn.disabled = !(hasAnyName && totalQty>0);
    }

    function renderSummaryAndPreview(){
      renderPreview();
      renderSummary();
    }

    function renderAll(){
      buildChipRow(root.querySelector('#bs-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#bs-colorRow'), COLORS, 'color');
      buildChipRow(root.querySelector('#bs-backingRow'), BACKINGS, 'backing');
      buildChipRow(root.querySelector('#bs-cornerRow'), CORNERS, 'corner');
      buildChipRow(root.querySelector('#bs-fontRow'), FONTS, 'font');
      buildChipRow(root.querySelector('#bs-imprintColorRow'), IMPRINT_COLORS, 'imprintColor');
      renderSummaryAndPreview();
    }

    function bindStaticControls(){
      const linesEl = root.querySelector('#bs-linesOfImprint');
      linesEl.value = state.linesOfImprint;
      linesEl.addEventListener('change', e=>{
        state.linesOfImprint = e.target.value;
        buildRowsDOM();
        renderSummaryAndPreview();
      });
      const logoEl = root.querySelector('#bs-logoOption');
      logoEl.value = state.logoOption;
      logoEl.addEventListener('change', e=>{
        state.logoOption = e.target.value;
        renderSummaryAndPreview();
      });
      root.querySelector('#bs-addRowBtn').addEventListener('click', ()=>{
        state.rows.push(newRow());
        buildRowsDOM();
        renderSummaryAndPreview();
      });
    }

    // ---- artwork file hook: Uploadery (and similar apps like Upload-Lift /
    // UploadKit) render as a real Shopify app block and follow the standard
    // Shopify line-item-property convention: name="properties[Some Label]".
    // Rather than hardcoding Uploadery's exact field name (which is
    // merchant-configurable in its own dashboard), we scan for ANY such
    // field inside this section and forward whatever we find — this works
    // for Uploadery specifically and generalizes to other upload apps too.
    function getAppBlockProperties(){
      const found = {};
      root.querySelectorAll('[name^="properties["]').forEach(el=>{
        const match = el.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        const key = match[1];
        const value = (el.type === 'checkbox') ? (el.checked ? (el.value||'on') : '') : el.value;
        if (value) found[key] = value;
      });
      return found;
    }
    // Picks whichever app-block property currently has a value, so the
    // preview can show the real uploaded logo instead of a placeholder box.
    // Assumes a single upload field is configured for this purpose — if a
    // merchant adds more than one, the first non-empty one wins.
    function getArtworkUrl(){
      const props = getAppBlockProperties();
      const keys = Object.keys(props);
      return keys.length ? props[keys[0]] : '';
    }
    (function watchAppBlockUploads(){
      // Uploadery's own field(s) render inside .bs-app-blocks once the
      // merchant adds the block; listen broadly since we don't control its
      // markup, and refresh both the status line and the live preview once
      // a file's been uploaded.
      root.addEventListener('change', ()=>{
        const props = getAppBlockProperties();
        const statusEl = root.querySelector('#bs-artworkStatus');
        if (statusEl) statusEl.textContent = Object.keys(props).length ? 'Artwork file attached ✓' : '';
        renderPreview();
      });
    })();

    function addToCart(){
      const variant = findVariant();
      if (!variant || !variant.available) return;
      const validRows = state.rows.filter(r=>r.name.trim()!=='' && (parseInt(r.qty,10)||0)>0);
      if (!validRows.length) return;

      const addBtn = root.querySelector('#bs-addBtn');
      const errorEl = root.querySelector('#bs-error');
      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      const appBlockProps = getAppBlockProperties();

      const count = lineCount(state.linesOfImprint);
      const titleOnly = isTitleOnly(state.linesOfImprint);
      const items = validRows.map((row, i)=>{
        const properties = {};
        properties[titleOnly ? 'Title (Line 1)' : 'Name (Line 1)'] = row.name;
        if (count>=2) properties['Title (Line 2)'] = row.line2;
        if (count>=3) properties['Company (Line 3)'] = row.line3;
        properties['Font'] = FONTS[state.font].label;
        properties['Corner Style'] = CORNERS[state.corner].label;
        properties['Imprint Color'] = IMPRINT_COLORS[state.imprintColor].label;
        properties['Logo Option'] = LOGO_LABELS[state.logoOption];
        // artwork applies to the whole order — attach once, on the first
        // line item, rather than duplicating it on every person's badge
        if (i===0) Object.assign(properties, appBlockProps);
        return { id: variant.id, quantity: parseInt(row.qty,10)||1, properties };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(res=>{
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(()=>{
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('bs-added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(()=>{
          addBtn.textContent = originalLabel;
          addBtn.classList.remove('bs-added');
          addBtn.disabled = false;
        }, 1800);
      })
      .catch(()=>{
        errorEl.textContent = "Something went wrong adding these to your cart. Please try again.";
        errorEl.style.display = '';
        addBtn.textContent = originalLabel;
        addBtn.disabled = false;
      });
    }

    buildRowsDOM();
    bindRowEvents();
    bindStaticControls();
    root.querySelector('#bs-addBtn').addEventListener('click', addToCart);
    renderAll();
    colorImagesReady.then(renderSummaryAndPreview);
  }

  document.querySelectorAll('script[data-section-id]').forEach(el=>{
    if (el.src && el.src.indexOf('badge-studio.js') !== -1) initSection(el);
  });
})();
